import * as React from 'react';
import { connect } from 'react-redux';
import { Layout, Alert, Divider } from 'antd';
import AdminSideNav from "./AdminSideNav";
import EmulationDTO from 'src/models/account/EmulationDTO';
import bindAllOfThis from 'src/utils/BindThisHelper';
import { withLocalize, LocalizeContextProps } from 'react-localize-redux';
import { ReduxStoreModel } from 'src/redux/ReduxModel';
import '../Layout.less';
import GeneralHeader from "src/layouts/GeneralHeader";
const { Content } = Layout;

interface AdminLayoutProps extends LocalizeContextProps {
    isEmulating: boolean;
}
interface AdminLayoutState {
    emulationInfo: EmulationDTO;
}

class AdminLayout extends React.Component<AdminLayoutProps, AdminLayoutState> {
    constructor(props: AdminLayoutProps) {
        super(props);
        bindAllOfThis(this, AdminLayout.prototype);
        this.state = {
            emulationInfo: null
        };
    }

    public render() {
        return <Layout className="admin">
            <GeneralHeader
                renderEmulationBanner={true}
                renderFullscreenToggle={true}
                renderLanguageToggle={true}
                renderAudioToggle={false}
                renderPlanetBox={false}
                renderBackToSpaceStation={false}
            />
            <Layout className="has-side-nav">
                <AdminSideNav />
                <Content>
                    {this.props.children}
                </Content>
            </Layout>
        </Layout>;
    }
}

function mapStateToProps(state: ReduxStoreModel) {
    return {
        isEmulating: state.User.isEmulating,
    };
}

export default connect(mapStateToProps)(withLocalize(AdminLayout));



// WEBPACK FOOTER //
// ./src/layouts/admin/AdminLayout.tsx